export const getFareOffersWithDetails = (state) => state.brandedFares.fareOffersWithDetails;
export const getSelectedFareToken = (state) => state.brandedFares.selectedFareToken;
export const getBrandedFaresFetchStatus = (state, offerToken) => {
    const fareOffer = state.brandedFares.fareOffersWithDetails[offerToken];
    return fareOffer?.fetchStatus ?? "initial";
};
export const getBrandedFaresComparisonTable = (state, offerToken) => {
    return state.brandedFares.fareOffersWithDetails[offerToken]?.comparisonTable;
};
export const getBrandedFaresComparisonTableCompact = (state, offerToken) => {
    return state.brandedFares.fareOffersWithDetails[offerToken]?.comparisonTableCompact;
};
export const getIsBrandedFaresLoading = (state, offerToken) => {
    return getBrandedFaresFetchStatus(state, offerToken) === "loading";
};
export const getIsBrandedFaresEmpty = (state, offerToken) => {
    const fareOffer = state.brandedFares.fareOffersWithDetails[offerToken];
    return ((fareOffer?.fetchStatus === "success" || fareOffer?.fetchStatus === "failed") &&
        (!fareOffer.brandedFareOffers || fareOffer.brandedFareOffers.length === 0));
};
